export const selectFilesReducer = (state, action) => {
  state.selectedFiles = Array.isArray(action.payload) ? [...action.payload] : [];
  state.selectedFile = state.selectedFiles[0] || {};
};

export const setRecentlyUploadedFileReducer = (state, action) => {
  state.recentlyUploadedFile = action.payload;
};

export const importFilesReducer = (state, action) => {
  state.importedFiles = [...state.importedFiles, ...action.payload];
};

export const clearImportedFilesReducer = (state) => {
  state.importedFiles = [];
};

export const resetShareListReducer = (state) => {
  state.shareList = {
    loading: false,
    value: [],
  };
};

export const setFilePreviewReducer = (state, action) => {
  const { id, preview } = action.payload;

  const file = state.items.value.find((item) => item.id === id);

  if (file) {
    file.preview = preview;
  }
};

export const clearPropertyFilesReducer = (state) => {
  state.items = {
    offset: 0,
    loading: true,
    hasMore: false,
    value: [],
  };
};

export const addMovingFilesReducer = (state, action) => {
  state.movingFiles = [...state.movingFiles, ...action.payload];
};

export const clearMovingFilesReducer = (state) => {
  state.movingFiles = [];
};

export const updateMovingFileStatusReducer = (state, action) => {
  const { id, status } = action.payload;
  const movingFiles = [...state.movingFiles];
  const fileIndex = movingFiles.findIndex((item) => item.id === id);
  if (fileIndex !== -1) {
    movingFiles[fileIndex] = { ...movingFiles[fileIndex], status };
    state.movingFiles = movingFiles;
  }
};

export const setActiveFolderReducer = (state, action) => {
  state.activeFolder = action.payload;
};
